<template>
  <v-bottom-sheet v-model="bottomSelectFlag">
    <v-sheet :height="sheetHeightObj.sheet" class="bottom-sheet-wrap">
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <v-container :style="containerStyle" class="pa-0 overflow-y-auto">
            <div class="sheet-title">파일첨부</div>
            <div class="sheet-desc" v-scroll.self="onScroll">
              <div class="d-flex justify-space-between fileSelect px-6">
                <v-btn
                  class="mr-1 fileBtn"
                  outlined
                  label
                  @click="[$emit('selectItem', 'C')]"
                >
                  <v-icon left> mdi-camera-wireless-outline </v-icon>
                  카메라
                </v-btn>
                <v-btn
                  class="ml-1 fileBtn"
                  outlined
                  label
                  @click="[$emit('selectItem', 'G')]"
                >
                  <v-icon left> mdi-image-multiple-outline </v-icon>
                  갤러리
                </v-btn>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    flag: {
      type: Boolean,
    },
    sheetHeightObj: {
      type: Object,
      default() {
        return { sheet: '283px', container: '253px' };
      },
    },
  },
  data: () => ({
    bottomSelectFlag: false,
  }),
  watch: {
    flag() {
      this.bottomSelectFlag = !this.bottomSelectFlag;
    },
  },

  computed: {
    containerStyle() {
      return {
        'max-height': this.sheetHeightObj.container,
      };
    },
  },
  methods: {
    onScroll() {},

    view() {
      this.flag = false;
    },
  },
  components: {},
};
</script>
<style>
.picker-group {
  display: flex;
}

/* bottom-sheet */
.bottom-sheet-wrap {
  border-radius: 20px 20px 0 0;
}
.sheet-title {
  padding: 30px 24px 20px;
  font-weight: bold;
  line-height: 1.5;
  color: #363c43;
}
</style>
